import { render, staticRenderFns } from "./ingredients.vue?vue&type=template&id=60f4df64&scoped=true"
import script from "./ingredients.vue?vue&type=script&lang=js"
export * from "./ingredients.vue?vue&type=script&lang=js"
import style0 from "./ingredients.vue?vue&type=style&index=0&id=60f4df64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f4df64",
  null
  
)

export default component.exports